import { useQuery } from "@tanstack/react-query";
import { ISystemIconProps } from "./SystemIcon";

const mappingUrl = "https://stdotlegalpublic.blob.core.windows.net/icons/mapping.json";
const systemIconMappingQueryKey = ["system-icon-mapping"] as const;

type SystemIconMapping = Record<string, string>;

async function fetchSystemIconMapping(): Promise<SystemIconMapping> {
    const response = await fetch(mappingUrl);
    if (!response.ok) {
        throw new Error(`icon mapping fetch failed: ${response.status}`);
    }
    return response.json();
}

export function useSystemIcon(props: ISystemIconProps) {
    const { data: mapping } = useQuery({
        queryKey: systemIconMappingQueryKey,
        queryFn: fetchSystemIconMapping,
        staleTime: 60_000,
        gcTime: 24 * 60 * 60_000,
    });

    const getIcon = () => {
        if (!props.systemName || !mapping) return null;
        return mapping[props.systemName.trim().toLowerCase()] ?? null;
    };

    return { getIcon };
}
